import { createSelector } from "@reduxjs/toolkit";
import { IAppState } from "../types";

const promptSelectors = (state: IAppState) => state.prompt;


export const getPrompts = createSelector(
    [promptSelectors],
    (app) => app?.prompt || []
);

export const getSelectedPrompts = createSelector(
    [promptSelectors],
    (app) => app?.selectedPrompts || []
);

export const allowUpsertPrompt = createSelector(
    [promptSelectors],
    (app) => app?.upsertPrompt,
);

export const getglobalPrompts = createSelector(
    [promptSelectors],
    (app) => app?.globalPrompt || []
);

export const getSelectedgGlobalPrompts = createSelector(
    [promptSelectors],
    (app) => app?.selectedglobalPrompts || []
);

export const allowUpsertglobalPrompt = createSelector(
    [promptSelectors],
    (app) => app?.upsertglobalPrompt,
);